import { isZendeskEnvProd } from "@/env/config";

const commonZendeskUrls = {
  mfaIntroduction: {
    prod: "https://help-top.mykenpo.com/hc/ja/articles/38456070660377/",
    dev: "https://help-top.dev.mykenpo.com/hc/ja/articles/10901023421711-mykenpo%E3%81%A7%E5%A4%9A%E6%AE%B5%E9%9A%8E%E8%AA%8D%E8%A8%BC-MFA%E8%AA%8D%E8%A8%BC-%E3%82%92%E8%A8%AD%E5%AE%9A%E3%81%99%E3%82%8B%E6%96%B9%E6%B3%95-%E9%96%8B%E7%99%BA%E7%92%B0%E5%A2%83",
  },
  // Cookieポリシーは本番のヘルプセンターのみで公開されているため、dev環境でも本番URLを参照する。
  cookiePolicy: {
    prod: "https://help-top.mykenpo.com/hc/ja/articles/58076102083865-mykenpo-Cookie-%E3%83%9D%E3%83%AA%E3%82%B7%E3%83%BC",
    dev: "https://help-top.mykenpo.com/hc/ja/articles/58076102083865-mykenpo-Cookie-%E3%83%9D%E3%83%AA%E3%82%B7%E3%83%BC",
  },
} as const satisfies Record<string, { prod: string; dev: string }>;

export const getCommonZendeskUrl = (key: keyof typeof commonZendeskUrls) => {
  return commonZendeskUrls[key][isZendeskEnvProd() ? "prod" : "dev"];
};
